import Icon, { ICONS } from "components/common/Icons";
import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";

function RiskAlarmAgreeModal({
  setModalOpen,
  isModalOpen,
  submitHandler,
}: any) {
  const modalRef = useModalClickOutside(setModalOpen);

  const [marketingAgree, setMarketingAgree] = useState(true);

  const { t } = useTranslation("detail");
  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="gap-[20px]"
    >
      <div className="flex flex-col gap-[30px] w-full">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-2">
            <h1 className={`${TYPO.TYPO4_B} text-gray80 whitespace-pre-line`}>
              {t("consent")}
            </h1>
            <span className={`${TYPO.TYPO7_MD} text-gray50`}>
              {t("consentDesc")}
            </span>
          </div>

          <div
            className="flex gap-[6px] p-1 cursor-pointer"
            onClick={() => setMarketingAgree(!marketingAgree)}
          >
            <Icon
              name={ICONS.CHECK}
              fill={marketingAgree ? "blue40" : "gray30"}
              width={20}
              height={20}
            />
            <span className={`${TYPO.TYPO8_RG} text-gray60 leading-[20px] `}>
              {t("requiredConsent")}
            </span>
          </div>
        </div>
        <Button
          type={"primary"}
          size={"lg"}
          text={t("agreeAndReceive")}
          width="w-full"
          disabled={!marketingAgree}
          clickHandler={async () => {
            if (marketingAgree) {
              // 클라이언트 api
              await submitHandler();
            }
          }}
        />
      </div>
    </BottomModal>
  );
}
export default RiskAlarmAgreeModal;
